/** What a write did to properties the ontology holds to one value: held values
 *  a later value replaced, and values not written because the store holds a
 *  later one. In plain words, or null when neither happened. */
export function valueUpdatesSentence(updated = 0, notAppliedOlder = 0): string | null {
  const parts: string[] = [];
  if (updated > 0) {
    parts.push(`${updated.toLocaleString()} ${updated === 1 ? 'value' : 'values'} updated`);
  }
  if (notAppliedOlder > 0) {
    parts.push(
      notAppliedOlder === 1
        ? '1 older value not applied, the store holds a later one'
        : `${notAppliedOlder.toLocaleString()} older values not applied, the store holds later ones`,
    );
  }
  return parts.length ? `${parts.join('; ')}.` : null;
}
